import React, { useContext, useState } from 'react';
import { Row, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TfiCheck } from 'react-icons/tfi';
import { CurrencyContext } from '../../utils/currencyContext';
import getCurrencySign from '../../utils/getCurrencySign';
import TableCollapse from '../tableCollapse';
import { resellerPlanPrices } from '../../resources/static/index';

function ResellerPlanColumns() {
    const { currentCurrency } = useContext(CurrencyContext);
    const { i18n, t } = useTranslation();
    const [openSections, setOpenSections] = useState({});
    const currentLanguage = i18n.language;
    const isFR = currentLanguage === 'fr';

    const getCurrencyCode = (currency) => {
        let currencyCode = 1;

        if (currency === 'usd') {
            currencyCode = 4;
        } else if (currency === 'gbp') {
            currencyCode = 5;
        }

        return currencyCode;
    };

    const toggleCollapse = (id) => {
        setOpenSections((prevSections) => ({
            ...prevSections,
            [id]: !prevSections[id]
        }));
    };
    const sign = getCurrencySign(currentCurrency);
    const dataReseller = resellerPlanPrices[currentCurrency];
    const green = '#00af60';

    return (
        <Row>
            <table width="100%" className="extended-plan-table" id="extended-plan-table">
                <thead>
                    <tr>
                        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                        <th />
                        <th className="plan-card">
                            <h2 className="plan-title">
                                Reseller <span>One</span>
                            </h2>
                            <p className="plan-text">
                                {t('reseller-hosting-page.reseller-plans-subtitle')}
                            </p>
                            <div className="plan-price">
                                <p className="price-info">
                                    <span className="price-home">
                                        {dataReseller.per_month}
                                        <sup>{sign}</sup>
                                    </span>
                                    /{t('titles.month')}
                                </p>
                                <p className="price-year">({t('titles.no-commitment')})</p>
                            </div>
                            <Nav className="common-nav-button yellow">
                                <Nav.Link
                                    className="navbar-brand"
                                    href={`https://obambu.com/my/cart.php?a=add&pid=148&systpl=${currentLanguage}&language=${isFR ? 'french' : 'english'}&currency=${getCurrencyCode(currentCurrency)}`}
                                    rel="noopener noreferrer"
                                >
                                    {t('buttons.order-now')}
                                </Nav.Link>
                            </Nav>
                        </th>
                    </tr>
                </thead>
                <tbody className="card-header">
                    <tr>
                        <th colSpan="5" className="sub-heading">
                            {t('reseller-hosting-page.ext-plans-column.table-1.title')}
                        </th>
                    </tr>
                </tbody>
                <tbody>
                    <tr>
                        <th>{t('reseller-hosting-page.ext-plans-column.table-1.property-1')}</th>
                        <td>10</td>
                    </tr>
                    <tr>
                        <th>{t('reseller-hosting-page.ext-plans-column.table-1.property-2')}</th>
                        <td>100{t('web-hosting-page.ext-plans-column.gb')}</td>
                    </tr>
                    <tr>
                        <th>{t('reseller-hosting-page.ext-plans-column.table-1.property-3')}</th>
                        <td>
                            {sign}
                            {dataReseller.extra_account} {t('titles.per')} {t('titles.account')} (
                            {t('titles.beyond')} 10 {t('titles.accounts')})
                        </td>
                    </tr>
                    <tr>
                        <th>{t('reseller-hosting-page.ext-plans-column.table-1.property-4')}</th>
                        <td>
                            {sign}
                            {dataReseller.extra_gb} {t('titles.per')}{' '}
                            {t('web-hosting-page.ext-plans-column.gb')} ({t('titles.beyond')} 100
                            {t('web-hosting-page.ext-plans-column.gb')})
                        </td>
                    </tr>
                    <tr>
                        <th>{t('reseller-hosting-page.ext-plans-column.table-1.property-5')}</th>
                        <td>{t('titles.unlimited')}</td>
                    </tr>
                    <tr>
                        <th>{t('reseller-hosting-page.ext-plans-column.table-1.property-6')}</th>
                        <td>
                            {' '}
                            <TfiCheck color={green} />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="table-wrapper">
                <TableCollapse
                    isOpen={!!openSections.section1}
                    toggle={toggleCollapse}
                    id="section1"
                    title={t('reseller-hosting-page.ext-plans-column.table-2.title')}
                >
                    <table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-2.property-1')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-2.property-2')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-2.property-3')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-2.property-4')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-2.property-5')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-2.property-6')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-2.property-7')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-2.property-8')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-2.property-9')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-2.property-10'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-2.property-11'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-2.property-12'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </TableCollapse>
            </div>
            <div className="table-wrapper">
                <TableCollapse
                    isOpen={!!openSections.section2}
                    toggle={toggleCollapse}
                    id="section2"
                    title={t('reseller-hosting-page.ext-plans-column.table-3.title')}
                >
                    <table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-3.property-1')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-3.property-2')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-3.property-3')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-3.property-4')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-3.property-5')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-3.property-6')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-3.property-7')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-3.property-8')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-3.property-9')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-10'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-11'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-12'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-13'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-14'
                                    )}
                                </th>
                                <td>+300</td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-15'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-16'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-17'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-18'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-19'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-3.property-20'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </TableCollapse>
            </div>
            <div className="table-wrapper">
                <TableCollapse
                    isOpen={!!openSections.section3}
                    toggle={toggleCollapse}
                    id="section3"
                    title={t('reseller-hosting-page.ext-plans-column.table-4.title')}
                >
                    <table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-4.property-1')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-4.property-2')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-4.property-3')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-4.property-4')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-4.property-5')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-4.property-6')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-4.property-7')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-4.property-8')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-4.property-9')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-4.property-10'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t(
                                        'reseller-hosting-page.ext-plans-column.table-4.property-11'
                                    )}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </TableCollapse>
            </div>
            <div className="table-wrapper">
                <TableCollapse
                    isOpen={!!openSections.section5}
                    toggle={toggleCollapse}
                    id="section5"
                    title={t('reseller-hosting-page.ext-plans-column.table-5.title')}
                >
                    <table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-5.property-1')}
                                </th>
                                <td>1 {t('web-hosting-page.ext-plans-column.cpu')}</td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-5.property-2')}
                                </th>
                                <td>
                                    2m
                                    {t('web-hosting-page.ext-plans-column.gb')}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-5.property-3')}
                                </th>
                                <td>{t('web-hosting-page.ext-plans-column.unlimited')}</td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-5.property-4')}
                                </th>
                                <td>{t('web-hosting-page.ext-plans-column.unlimited')}</td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-5.property-5')}
                                </th>
                                <td>25</td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-5.property-6')}
                                </th>
                                <td>100</td>
                            </tr>
                        </tbody>
                    </table>
                </TableCollapse>
            </div>
            <div className="table-wrapper">
                <TableCollapse
                    isOpen={!!openSections.section6}
                    toggle={toggleCollapse}
                    id="section6"
                    title={t('reseller-hosting-page.ext-plans-column.table-6.title')}
                >
                    <table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-6.property-1')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-6.property-2')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-6.property-3')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-6.property-4')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-6.property-5')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('reseller-hosting-page.ext-plans-column.table-6.property-6')}
                                </th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </TableCollapse>
            </div>
        </Row>
    );
}

export default ResellerPlanColumns;
